const ACTION_PLAN_BASE_STATUS = {
  NOT_STARTED: 1,
  IN_PROGRESS: 2,
  COMPLETE: 3,
} as const;

export const ACTION_PLAN_STATUS = ACTION_PLAN_BASE_STATUS;

export enum ACTION_PLAN_SOURCE {
  AI_COMPETITIVE_INTELLIGENCE = 1,
  ALERTS = 2,
  USER_ADDED = 3,
}

export const ACTION_PLAN_SOURCE_LABEL: Record<number, string> = {
  [ACTION_PLAN_SOURCE.AI_COMPETITIVE_INTELLIGENCE]: 'AI-generated (from AI Competitive Intelligence)',
  [ACTION_PLAN_SOURCE.ALERTS]: 'AI-generated (from Alerts)',
  [ACTION_PLAN_SOURCE.USER_ADDED]: 'User Added',
};

export const ACTION_PLAN_STATUS_LABEL: Record<number, string> = {
  [ACTION_PLAN_STATUS.NOT_STARTED]: 'Not Started',
  [ACTION_PLAN_STATUS.IN_PROGRESS]: 'In Progress',
  [ACTION_PLAN_STATUS.COMPLETE]: 'Complete',
};

export const ACTION_PLAN_STATUS_BG_COLOR_MAP: Record<number, string> = {
  [ACTION_PLAN_STATUS.NOT_STARTED]: 'var(--background)',
  [ACTION_PLAN_STATUS.IN_PROGRESS]: 'var(--pale-blue)',
  [ACTION_PLAN_STATUS.COMPLETE]: 'var(--light-green)',
};

export const ACTION_PLAN_ITEM_TYPE_OPTIONS = [
  { id: 1, name: 'Sales' },
  { id: 2, name: 'Operations' },
  { id: 3, name: 'Marketing' },
  { id: 4, name: 'Other' },
];

export enum ACTION_PLAN_SOURCE_INSIGHT {
  AMENITIES = 1,
  ONLINE_REVIEWS = 2,
  DINING = 3,
  ACTIVITIES = 4,
  APARTMENTS = 5,
  COMMUNITY_FIRST_IMPRESSION = 6,
  WEBSITE_EXPERIENCE = 7,
  EMAIL_MARKETING = 8,
  SPEED_TO_LEAD = 9,
}

export const ACTION_PLAN_SOURCE_INSIGHT_LABEL: Record<number, string> = {
  [ACTION_PLAN_SOURCE_INSIGHT.AMENITIES]: 'Amenities',
  [ACTION_PLAN_SOURCE_INSIGHT.ONLINE_REVIEWS]: 'Online Reviews',
  [ACTION_PLAN_SOURCE_INSIGHT.DINING]: 'Dining',
  [ACTION_PLAN_SOURCE_INSIGHT.ACTIVITIES]: 'Activities',
  [ACTION_PLAN_SOURCE_INSIGHT.APARTMENTS]: 'Apartments',
  [ACTION_PLAN_SOURCE_INSIGHT.COMMUNITY_FIRST_IMPRESSION]: 'Community First Impression',
  [ACTION_PLAN_SOURCE_INSIGHT.WEBSITE_EXPERIENCE]: 'Website Experience',
  [ACTION_PLAN_SOURCE_INSIGHT.EMAIL_MARKETING]: 'Email Marketing',
  [ACTION_PLAN_SOURCE_INSIGHT.SPEED_TO_LEAD]: 'Speed to Lead',
};

export const ACTION_PLAN_ALERT_TYPE_LABEL: Record<number, string> = {
  1: 'Incentive Alert',
  2: 'Market Rate Alert',
  3: 'Review Alert',
  4: 'Review Alert',
};
